<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showNavigation: false
        }
    },
    methods: {
        toggleNavigation() {
            this.showNavigation = !this.showNavigation;
        }
    },
    components: {}
}
</script>
